import React from 'react';

const FAQBlock = ({ faqs = [], onFaqsChange }) => {
  const addFAQ = () => {
    onFaqsChange([...faqs, { question: '', answer: '' }]);
  };

  const removeFAQ = (index) => {
    const newFaqs = faqs.filter((_, i) => i !== index);
    onFaqsChange(newFaqs);
  };

  const updateFAQ = (index, field, value) => {
    const newFaqs = [...faqs];
    newFaqs[index] = { ...newFaqs[index], [field]: value };
    onFaqsChange(newFaqs);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-medium text-gray-900">FAQ Section</h3>
          <p className="text-sm text-gray-500">
            Add frequently asked questions to help with SEO and user engagement
          </p>
        </div>
        <button
          type="button"
          onClick={addFAQ}
          className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Add FAQ
        </button>
      </div>

      {faqs.length === 0 && (
        <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-gray-900">No FAQs yet</h3>
          <p className="mt-1 text-sm text-gray-500">
            Get started by adding some frequently asked questions.
          </p>
        </div>
      )}

      {faqs.map((faq, index) => (
        <div key={index} className="border border-gray-200 rounded-lg p-4 space-y-4">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-900">FAQ #{index + 1}</h4>
            <button
              type="button"
              onClick={() => removeFAQ(index)}
              className="text-red-600 hover:text-red-800"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Question *
            </label>
            <input
              type="text"
              value={faq.question}
              onChange={(e) => updateFAQ(index, 'question', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="What is the most common question about this project?"
              maxLength={200}
            />
            <p className="mt-1 text-xs text-gray-500">
              {faq.question.length}/200 characters
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Answer *
            </label>
            <textarea
              value={faq.answer}
              onChange={(e) => updateFAQ(index, 'answer', e.target.value)}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Provide a helpful answer to the question..."
              maxLength={500}
            />
            <p className="mt-1 text-xs text-gray-500">
              {faq.answer.length}/500 characters
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQBlock;
